import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BulkUploadPayload } from '../../../../mediator-commlibs/interfaces/request/restaurantSetting.interface';
import { BulkUploadResponse } from '../../../../mediator-commlibs/interfaces/response/restaurantSetting.interface';

@Injectable({
  providedIn: 'root'
})
export class BulkUploadService {
  constructor(private http: HttpClient) {}

  bulkUpload(payload: BulkUploadPayload): Observable<BulkUploadResponse> {
    return this.http.post<BulkUploadResponse>('v1/restaurant-configurations/bulkUpload', payload);
  }  
}